import { ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGS } from "@/lib/i18n";
import { TID } from "@/constants/testIds";

export const LANG_META = {
  it: ["Italiano", "it"], en: ["English", "gb"], de: ["Deutsch", "de"], fr: ["Français", "fr"], es: ["Español", "es"],
  pt: ["Português", "pt"], ru: ["Русский", "ru"], zh: ["中文", "cn"], ja: ["日本語", "jp"], ar: ["العربية", "sa"],
};

const Flag = ({ code }) => <img src={`https://flagcdn.com/w40/${LANG_META[code][1]}.png`} alt="" className="w-5 h-3.5 object-cover rounded-[2px] shadow-sm" loading="lazy" />;

export const LangSelect = ({ lang, setLang }) => (
  <DropdownMenu>
    <DropdownMenuTrigger data-testid={TID.langToggle} aria-label="Lingua / Language"
      className="inline-flex items-center gap-2 rounded-sm border border-[#e4e4e7] bg-white text-xs h-8 px-2 hover:border-[#2B3036] transition-colors">
      <Flag code={lang} /> <span className="hidden sm:inline">{LANG_META[lang][0]}</span> <ChevronDown className="w-3 h-3 text-[#71717a]" />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="max-h-[70vh] overflow-y-auto">
      {LANGS.map((l) => (
        <DropdownMenuItem key={l} data-testid={`lang-option-${l}`} onSelect={() => setLang(l)}
          className={`gap-2 text-sm cursor-pointer ${l === lang ? "font-semibold" : ""}`}>
          <Flag code={l} /> {LANG_META[l][0]}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
